// @ts-check
import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { Paper } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar/Avatar';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(0),
    width: '100%',
    backgroundColor: theme.palette.background.paper
  },
  container: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  sectionHeading: {
    margin: theme.spacing(3)
  },
  contractHeader: {
    textAlign: 'center'
  },
  clientLogo: {
    height: '8rem',
    width: '8rem',
    objectFit: 'contain'
  },
  large: {
    height: '8rem',
    width: '8rem',
    objectFit: 'contain'
  },
  margin: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },

  paper: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    cursor: 'pointer'
  },
  driverAvatarContainer: {
    justifyContent: 'center',
    display: 'flex'
  },
  driverAvatar: {
    width: '7rem',
    height: '7rem'
  }
}));

export function UserImageComponent({ user }) {
  const classes = useStyles();

  return (
    <>
      <Paper className={classes.paper} elevation={0}>
        <div className={classes.driverAvatarContainer}>
          <Avatar
            className={classes.driverAvatar}
            alt={user.name}
            src={user.image || '/static/images/avatar/1.jpg'}
          />
        </div>
        <br />
        <div>
          <b>{user.name}</b>
        </div>
      </Paper>
    </>
  );
}
